export function TopSwoop() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1430 140"
      fill="#FFF"
      style={{
        position: "relative",
        bottom: "-10px",
        width: "100%",
        zIndex: "0",
      }}
    >
      <path d="M0 140h1440V46.75C1360.635 15.583 1268.302 0 1163 0 812.13 0 674 113.78 370.736 127.279 188.866 135.374 65.286 119.625 0 80.03V140z" />
    </svg>
  );
}
